import api from "../../../services/axiosConfig";

export const fetchExecutors = async () => {
  try {
    const response = await api.get(
      "/instances/skeye/skeyeingest/list-executors",
      {
        data: {},
      },
    );
    return response.data.data.executors;
  } catch (error) {
    console.error("Error fetching executers:", error);
    throw error;
  }
};

export const deleteExecuter = async (executerId) => {
  try {
    const response = await api.delete(
      `/instances/skeye/skeyeingest/delete-executor/${executerId}`,
      {
        data: {},
      },
    );
    return response;
  } catch (error) {
    console.error("Error deleting Executor:", error);
    throw error;
  }
};

export const addExecuter = async (newExecuter) => {
  try {
    const data = new FormData();
    data.append("file", newExecuter.file);

    const response = await api.post(
      "/instances/skeye/skeyeingest/upload-executor",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        maxBodyLength: Infinity,
        Connection: "keep-alive",
        accept: "*/*",
        timeout: 600000,
      },
    );
    return response;
  } catch (error) {
    console.error("Error adding Executor:", error);
    throw error;
  }
};
